import { MessageDescriptor } from 'react-intl';

export function isMessageDescriptor(arg: unknown): arg is MessageDescriptor {
  return typeof arg === 'object' && arg !== null && 'id' in arg && 'defaultMessage' in arg;
}
